import React, { useContext } from 'react';
import axios from "../../../../common/axios";
import {isCancel} from 'axios';
import {ACTION_TYPE} from "./enums";
import useCurrentShortcut from "../../../../hooks/useCurrentShortcut";
import {BrandContext} from "../../../../common/BrandContext";

const searchStudentTrails = (params, handleTableData, handlePagingData, abortController) => {

    if (params.hasOwnProperty('assignmentState') && params.hasOwnProperty('pageNumber')) {
        axios.get('/web/ui/trail/searchStudentTrails', {params: params, signal:abortController.signal})
            .then((response) => {
                // console.log('response: ', response);
                if (response && response.data) {
                    handleTableData(dataAdapterTrailAssignments(response.data.currPageContents));
                    const {currPage, pageSize, totalResults} = response.data;
                    handlePagingData({currPage, pageSize, totalResults});
                }
                // handleSetData(response);
            }).catch((error) => {
                //throws error if not purposefully cancelled
                if (!isCancel(error)) {
                    console.error('Error fetching searchStudentTrails data.');
                    throw error;
                }

            }).finally(()=>{
                abortController = null;
            });

    } else {
        console.error('Missing params values for searchStudentTrails.');
    }
}

const StartViewPathwayAssignment = ()=> {
    const brandConfig = useContext(BrandContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const startOrViewPathwayAssignment = (params) => {
        const {pathwayAssignmentId, pathwayType, disabled, actionType, conceptId, noResults} = params;
        if (pathwayAssignmentId != undefined && !disabled) {
            const readOnly = actionType === ACTION_TYPE.VIEW_PATHWAY;
            if (noResults && readOnly) {
                openTrailNoResultsDialog(pathwayAssignmentId);
            } else if (pathwayType === 'TASK') {
                if(brandConfig.useReactStudentTrail) {
                    loadShortcutByUrl('/web/ui/view/studentTrail', undefined, pathwayAssignmentId);
                } else {
                    loadShortcutByUrl('/trail/loadTrail.action', {currentPathwayAssignmentId: pathwayAssignmentId});
                }
            } else if (pathwayType === 'PATHWAY' && conceptId !== undefined && conceptId !== '') {
                loadShortcutByUrl('/trail/loadTrail.action', {
                    currentPathwayAssignmentId: pathwayAssignmentId,
                    conceptId: conceptId
                });
            } else if(pathwayType === 'PATHWAY' && conceptId == undefined) {
                loadShortcutByUrl('/web/ui/view/studentTrailLessons', undefined, pathwayAssignmentId);
            }
        }
    }
    return {startOrViewPathwayAssignment}
}
const dataAdapterTrailAssignments = (data) => {
    // console.log('dataAdapterTrailAssignments: ', data);
    const tableData = [];
    data.forEach((row) => {
        const {pathwayAssignment,activeStep} = row;
        row.noResults = row.totalPathwayUsers === 0;
        tableData.push({
            key: pathwayAssignment.pathwayAssignmentId,
            planName: {key:pathwayAssignment.pathwayAssignmentId, message:pathwayAssignment.message, name:pathwayAssignment.pathwayAssignmentName, pathwayIcons: row.pathwayAssignment.pathwayIcons},
            teacher: pathwayAssignment.recipientGroup === 'STUDENT_SELF' ? 'Auto-generated' : pathwayAssignment.assignTeacher,
            currentLesson: activeStep ? activeStep.conceptName : '',
            currentStep: row,
            activity: row,
            assigned: pathwayAssignment.assignedDate,
            updated: row.updatedDate,
            action: row
        })
    });
    return tableData;
}
export {searchStudentTrails, StartViewPathwayAssignment};